import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=01f9cc32&"
import script from "./Cookies.vue?vue&type=script&lang=js&"
export * from "./Cookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports